var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTests({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9118 4.21881L14.5591 2.81473L15.0737 2.29053L16.4264 3.69461L15.9118 4.21881Z",
    fill: "#572580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7754 5.40094L13.4231 3.99667L13.9377 3.47266L15.29 4.87692L14.7754 5.40094Z",
    fill: "#572580"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6366 6.58325L12.2844 5.1788L12.799 4.65479L14.1512 6.05924L13.6366 6.58325Z",
    fill: "#572580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4974 7.76545L11.1458 6.36044L11.6607 5.83643L13.0123 7.24162L12.4974 7.76545Z",
    fill: "#572580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3589 8.94824L10.0071 7.5436L10.522 7.01978L11.8738 8.42441L11.3589 8.94824Z",
    fill: "#572580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2206 10.1303L8.86841 8.72586L9.38298 8.20166L10.7351 9.6063L10.2206 10.1303Z",
    fill: "#572580"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0819 11.3125L7.72974 9.90805L8.24431 9.38403L9.59648 10.7885L9.0819 11.3125Z",
    fill: "#572580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94555 12.4947L6.59375 11.0904L7.10833 10.5664L8.46013 11.9707L7.94555 12.4947Z",
    fill: "#572580"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80688 13.6771L5.45508 12.2728L5.96965 11.7488L7.32146 13.153L6.80688 13.6771Z",
    fill: "#572580"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66821 14.8594L4.31641 13.4547L4.83134 12.9309L6.18315 14.3355L5.66821 14.8594Z",
    fill: "#572580"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52972 16.0417L3.17773 14.6371L3.69267 14.113L5.04466 15.5179L4.52972 16.0417Z",
    fill: "#572580"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6574 16.0804L3.14282 15.5563L15.3447 2.88184L15.8593 3.40585L3.6574 16.0804Z",
    fill: "#572580"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_1716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0625 0.71875H17.9375V19.2812H0.0625V0.71875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_1716)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5045 1.46364C15.1134 1.46364 14.7455 1.62211 14.4687 1.90982L2.7024 14.1316C2.24739 14.6043 2.14237 15.3463 2.4471 15.9363L2.57203 16.1784L0.884903 17.9301C0.751642 18.0688 0.751461 18.2951 0.885084 18.434C1.01201 18.566 1.23254 18.566 1.35983 18.4338L3.05003 16.678L3.28885 16.8111C3.86246 17.1309 4.55646 17.0242 5.01654 16.5461L16.783 4.32413C17.3568 3.72823 17.3568 2.75804 16.7832 2.16158L16.5405 1.90982C16.2635 1.62211 15.8956 1.46364 15.5045 1.46364ZM1.12309 19.2813C0.839004 19.2813 0.571757 19.1664 0.371142 18.958C-0.0402296 18.5303 -0.0404106 17.8342 0.370779 17.4062L1.69524 16.0312C1.38255 15.1983 1.56651 14.2538 2.18863 13.6074L13.9549 1.38578C14.3688 0.955618 14.9194 0.71875 15.5053 0.71875C16.0912 0.71875 16.6418 0.955432 17.0558 1.38559L17.2986 1.63736C18.1506 2.52282 18.1504 3.96322 17.2982 4.84831L5.53211 17.0701C4.92031 17.7061 3.99363 17.901 3.1966 17.5854L1.87522 18.958C1.67442 19.1664 1.40735 19.2813 1.12309 19.2813Z",
    fill: "#572580"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTests);
export default __webpack_public_path__ + "static/media/tests.987b1e762e56ba7ed38a738e00e6fc5b.svg";
export { ForwardRef as ReactComponent };